import clsx from "clsx";
import React from "react";
import { Link } from "~/components/Elements";
import img from "./img/banner-cofoe.png";
import img2 from "./img/banner-cofoe@2x.png";
const url = "/tag/cofoe";

const HeaderBanner = (props) => {
  return (
    <div className={clsx("bannerBase", props.className)}>
      <Link to={url}>
        <div className="bannerBase-inner-inner-bg ">
          <img
            src={img}
            srcSet={`${img} 1x, ${img2} 2x`}
            alt="Prehľad očakávaných udalostí dnešného dňa"
            width="300"
            height="150"
            style={{marginBottom: "1em"}}
            loading="lazy"
          ></img>
        </div>
      </Link>
    </div>
  );
};

export default HeaderBanner;
